import common_en from './common.json';
import components_en from './components.json';
import links_en from './links.json';

export default {
  common: common_en,
  components: components_en,
  links: links_en,
};
